/* FLM — i18n: English (LTR, PRIMARY) + Persian/Farsi (RTL, best-effort).
   makeT(lang) returns t(key, vars). Missing keys fall back to EN, then to the key itself.
   Screen-port strings live in i18n.additions.js (merged below); the long-term plan is
   admin-managed translations (docs/09-admin-panel.md). */
import { I18N_ADDITIONS } from './i18n.additions';

export const FLM_I18N = {
  en: {
    appName: 'Find Love Mate',
    tagline: 'Find your person.',
    splashSub: 'Premium dating, inside Telegram',
    continue: 'Continue',
    skip: 'Skip',
    back: 'Back',
    next: 'Next',
    done: 'Done',
    save: 'Save',
    seeAll: 'See all',
    online: 'Online',
    verified: 'Verified',
    km: 'KM',
    step: 'Step',

    /* Onboarding */
    obLoginTitle: 'Signed in, in seconds',
    obLoginBody: 'We use your Telegram account. No email, no password, no forms.',
    obLoginCta: 'Continue with Telegram',
    obLoginPrivacy: 'We never post or message on your behalf.',
    obNameTitle: "What's your name?",
    obNamePh: 'First name',
    obBirthTitle: 'Your birthday',
    obBirthNote: 'Your profile shows your age, never the date.',
    obGenderTitle: 'I am…',
    obLookingTitle: 'Show me…',
    woman: 'Women',
    man: 'Men',
    everyone: 'Everyone',
    iWoman: 'Woman',
    iMan: 'Man',
    iNonbinary: 'Nonbinary',
    obInterestsTitle: 'Your interests',
    obInterestsNote: 'Pick at least 3 — they power your matches.',
    obPhotosTitle: 'Add your photos',
    obPhotosNote: 'Drag real photos in. The first one is your cover.',
    obVoiceTitle: 'Record a voice intro',
    obVoiceNote: 'Eight seconds. Let them hear you, not just see you.',
    holdToRecord: 'Hold to record',
    recording: 'Recording…',
    soundsGreat: 'Sounds great',
    obLocationTitle: 'Enable location',
    obLocationNote: 'We match you with people nearby. Your precise location stays private.',
    enableLocation: 'Enable location',
    startMatching: 'Start matching',

    /* Splash + 5-step wizard (canvas artboards) */
    splashMonoRow: 'Find · Love · Mate',
    splashTagline: 'Curated dating inside Telegram. Private by design, premium by default.',
    splashPrivacy: 'No phone number shared · Telegram ID only',
    obStep1Label: 'Identity',
    obStep2Label: 'Intent',
    obStep3Label: 'Presence',
    obStep4Label: 'Taste',
    obStep5Label: 'Radius',
    obIdTitle: 'Imported from Telegram',
    obLinked: 'Linked',
    obTgVerified: 'Telegram verified',
    obDisplayName: 'Display name',
    obBirthday: 'Birthday',
    obDayPh: 'DD',
    obMonthPh: 'MM',
    obYearPh: 'YYYY',
    obAgeNote: "You're {age} — age is public, birthday isn't.",
    obPhonePrivacy: 'Your Telegram phone number is never revealed. Matches see your FLM profile only.',
    obErrDay: 'Enter a valid day (1–31)',
    obErrMonth: 'Enter a valid month (1–12)',
    obErrYear: 'Enter a valid year ({min}–{max})',
    obErrDate: "That date doesn't exist — check the day and month.",
    obErrFuture: "Your birthday can't be in the future.",
    obErrAge: 'You must be 18 or older to use FLM.',
    obIntentTitle: 'Who are you here for?',
    obIAm: 'I am',
    obShowMe: 'Show me',
    obBeyond: 'Beyond',
    obLookingFor: 'Looking for',
    obReal: 'The real thing',
    obRealSub: 'Long-term, exclusive',
    obOpen: 'Open to see',
    obOpenSub: 'Dating, no pressure',
    obFriends: 'Friends first',
    obFriendsSub: 'Slow burn, events & meetups',
    obPresenceTitle: 'Show your best light',
    obMainPhoto: 'Main photo',
    obNMore: '{n} more',
    obAiCheck: 'Photos are AI-checked for authenticity → earns the {verified} badge.',
    obVerifiedWord: 'verified',
    obVoiceBoost: 'Profiles with a voice intro get 3× more matches.',
    obSkipVoice: 'Voice intro — record later',
    obTasteTitle: 'Pick 5 things you love',
    obPromptLabel: 'Your opening prompt',
    obTwoTruths: 'Two truths & a lie',
    obPromptExample: "I've DJ'd in three countries, I hold a patent, and I've never tried sushi.",
    obPromptHint: 'Matches guess the lie to break the ice 🧊',
    obShuffle: 'Shuffle prompt',
    obRadiusTitle: 'Where love finds you',
    obDiscoveryRadius: 'Discovery radius',
    obGhostMode: 'Ghost mode',
    obGhostSub: 'Browse the map unseen · Premium',
    obEnterFlm: 'Enter FLM',
    obLocationOff: 'Use city only — exact location off',
    obLocationRequired: 'Set your location to continue — enable it, drop a pin, or enter your city.',
    /* wizard rework: required main photo + crop, voice review, real map */
    obMainPhotoReq: 'Add at least 2 photos — your main and one more',
    obVerifying: 'Checking your photos… they need to be real photos of you.',
    obAiChecking: 'AI checking…',
    photoMinRemove: 'Keep at least 2 photos — add a new one before removing this.',
    obCropTitle: 'Adjust your photo',
    obCropHint: 'Drag to reposition · slide or pinch to zoom',
    obCropAvatar: 'Avatar preview — how matches see you',
    obCropUse: 'Use photo',
    obZoom: 'Zoom',
    cancel: 'Cancel',
    obRecordVoice: 'Record voice intro',
    obStopRec: 'Stop',
    obOptional: 'optional',
    micUnavailable: 'Microphone unavailable',
    obLocating: 'Locating you…',
    obUploadErr: "Photo upload didn't go through — tap the slot to try again.",
    obFinishErr: 'Could not finish sign-up',
    obFinishing: 'Saving your profile…',

    /* App update prompt */
    updateTitle: 'A new version is available',
    updateBody: 'Refresh to get the latest FLM.',
    updateCta: 'Refresh',

    /* Discover */
    discover: 'Discover',
    deck: 'Deck',
    orbit: 'Orbit',
    likesYou: 'Likes you',
    filters: 'Filters',
    distance: 'Distance',
    ageRange: 'Age range',
    filterGlobal: 'GLOBAL',
    likesPaywallCta: 'See who likes you — go Premium',
    pass: 'Pass',
    like: 'Yes',
    spark: 'Spark',
    matchTitle: "It's a match",
    matchBody: 'You and {name} said yes to each other.',
    sendMessage: 'Send a message',
    keepSwiping: 'Keep swiping',
    about: 'About',
    interests: 'Interests',
    voiceIntro: 'Voice intro',
    inCommon: '{n} in common',
    deckEmpty: "You're all caught up",
    deckEmptyBody: 'New people appear every day. Widen your filters or check back soon.',
    orbitHint: 'Tap a face to open their card',
    youCenter: 'You',

    /* Favorites / likes */
    favorites: 'Favorites',
    likedYouN: '{n} people like you',
    revealLikes: 'See who likes you',
    revealNote: 'Upgrade to Premium to reveal them instantly.',

    /* Feed */
    pulse: 'Pulse',
    stories: 'Stories',
    yourStory: 'Your story',
    reply: 'Reply',
    shareMoment: 'Share a moment…',
    likedYourPost: 'liked your post',

    /* Map */
    nearby: 'Nearby',
    radius: 'Radius',
    liveNow: 'Live now',
    eventsNearby: 'Events nearby',
    going: '{n} going',
    join: 'Join',
    joined: 'Joined',

    /* Chats */
    chats: 'Chats',
    newMatches: 'New matches',
    icebreakers: 'Icebreakers',
    typeMessage: 'Message…',
    photoMessage: 'Photo',
    viewProfile: 'View profile',
    gift: 'Gift',
    sendGift: 'Send a gift',
    giftNote: 'Bought with TON, delivered instantly to their profile.',
    videoCall: 'Video call',
    chatLimitTitle: 'Daily limit reached',
    chatLimitBody: 'Go Premium for unlimited messages',
    today: 'Today',
    you: 'You',
    sentGift: 'You sent a gift',
    unmatch: 'Unmatch',
    unmatchSub: 'Remove the match & conversation',
    blockSub: "You won't see each other again",
    reportSub: 'Flag this profile to our team',
    reportWhy: 'What happened?',
    rrSpam: 'Spam',
    rrHarassment: 'Harassment',
    rrNudity: 'Inappropriate content',
    rrScam: 'Scam',
    rrFake: 'Fake profile',
    rrOther: 'Other',
    /* report wizard */
    reportStepReason: 'Reason',
    reportStepDetails: 'Details',
    reportDetailsTitle: 'Add details',
    reportDetailsSub: 'Anything that helps our team review this (optional).',
    reportDetailsPlaceholder: 'Describe what happened…',
    reportSend: 'Send report',
    reportSending: 'Sending…',
    reportSentTitle: 'Report sent',
    reportSentSub: "Thanks for helping keep FLM safe. Our team will review this — and we've blocked them, so you won't see each other again.",
    blockTitle: 'Block this person?',
    blockBody: "They won't be able to see you or message you, and any match is removed. You can undo this later.",
    reportFailed: "Couldn't send — please try again.",

    /* Premium */
    premium: 'Premium',
    premiumTitle: "Date like it's first class",
    premiumSub: 'Unlimited everything. Seen first, everywhere.',
    mostPopular: 'Most popular',
    upgrade: 'Upgrade',
    month: 'mo',
    months: 'months',
    payWithCrypto: 'Pay with crypto',
    checkout: 'Checkout',
    coin: 'Coin',
    amount: 'Amount',
    address: 'Address',
    copy: 'Copy',
    copied: 'Copied',
    ivePaid: "I've paid",
    verifying: 'Verifying on-chain…',
    youArePremium: "You're Premium",
    premiumDoneBody: 'Welcome to {plan}. Everything is unlimited now.',
    tgStars: 'Telegram Stars',
    perkUnlimited: 'Unlimited yes & rewinds',
    perkSeeLikes: 'See everyone who likes you',
    perkBoost: '1 free Boost every week',
    perkSparks: '5 Sparks a day',
    perkIncognito: 'Incognito browsing',
    perkPassport: 'Passport — date any city',
    perkVerifiedOnly: 'Verified-only matching',
    perkConcierge: 'Profile concierge & review',
    /* Per-tier entitlement perks — each plan card shows its REAL numbers. */
    perkSparks5: '5 Sparks a day',
    perkSparks10: '10 Sparks a day',
    perkBoost1: '1 free Boost every week',
    perkBoost3: '3 free Boosts every week',
    perkRewind: 'Rewind your last swipe',
    perkMessageFirst: 'Message before you match',

    /* Profile */
    profile: 'Profile',
    editProfile: 'Edit profile',
    epSub: 'Bio, job, interests & photos',
    epBioPh: 'A few lines about you…',
    epJobPh: 'What do you do?',
    job: 'Job',
    settings: 'Settings',
    language: 'Language',
    photos: 'Photos',
    strength: 'Profile strength',
    getVerified: 'Get verified',
    verifiedNote: 'A 10-second video selfie. Keeps FLM real.',
    wallet: 'Wallet',
    boost: 'Boost',
    boostNote: 'Be the top profile nearby for 30 min',
    notifications: 'Notifications',
    privacy: 'Privacy',
    logout: 'Log out',
    memberSince: 'Member since',
  },

  fa: {
    appName: 'فایند لاو میت',
    tagline: 'نیمه‌ی گم‌شده‌ات را پیدا کن.',
    splashSub: 'دوست‌یابی ممتاز، داخل تلگرام',
    continue: 'ادامه',
    skip: 'رد کردن',
    back: 'بازگشت',
    next: 'بعدی',
    done: 'تمام',
    save: 'ذخیره',
    seeAll: 'مشاهده همه',
    online: 'آنلاین',
    verified: 'تأییدشده',
    km: 'کیلومتر',
    step: 'مرحله',

    obLoginTitle: 'ورود در چند ثانیه',
    obLoginBody: 'با حساب تلگرام شما وارد می‌شویم. بدون ایمیل، بدون رمز عبور.',
    obLoginCta: 'ادامه با تلگرام',
    obLoginPrivacy: 'هرگز از طرف شما پیام یا پستی ارسال نمی‌کنیم.',
    obNameTitle: 'اسم شما چیست؟',
    obNamePh: 'نام',
    obBirthTitle: 'تاریخ تولد شما',
    obBirthNote: 'پروفایل فقط سن شما را نشان می‌دهد، نه تاریخ را.',
    obGenderTitle: 'من …',
    obLookingTitle: 'نشانم بده …',
    woman: 'زنان',
    man: 'مردان',
    everyone: 'همه',
    iWoman: 'زن',
    iMan: 'مرد',
    iNonbinary: 'نان‌باینری',
    obInterestsTitle: 'علاقه‌مندی‌های شما',
    obInterestsNote: 'حداقل ۳ مورد انتخاب کنید — پایه‌ی پیشنهادهای ما.',
    obPhotosTitle: 'عکس‌هایتان را اضافه کنید',
    obPhotosNote: 'عکس‌های واقعی را بکشید و رها کنید. اولی کاور شماست.',
    obVoiceTitle: 'معرفی صوتی ضبط کنید',
    obVoiceNote: 'هشت ثانیه. بگذارید صدایتان را بشنوند، نه فقط عکس‌تان را.',
    holdToRecord: 'برای ضبط نگه دارید',
    recording: 'در حال ضبط…',
    soundsGreat: 'عالی شد',
    obLocationTitle: 'موقعیت مکانی را فعال کنید',
    obLocationNote: 'افراد نزدیک شما را پیشنهاد می‌دهیم. موقعیت دقیق شما خصوصی می‌ماند.',
    enableLocation: 'فعال‌سازی موقعیت',
    startMatching: 'شروع آشنایی',

    /* اسپلش + ویزارد ۵ مرحله‌ای (آرت‌بردهای کانوس) */
    splashMonoRow: 'فایند · لاو · میت',
    splashTagline: 'دوست‌یابی دست‌چین داخل تلگرام. خصوصی در طراحی، پرمیوم به‌صورت پیش‌فرض.',
    splashPrivacy: 'بدون اشتراک شماره تلفن · فقط آیدی تلگرام',
    obStep1Label: 'هویت',
    obStep2Label: 'نیت',
    obStep3Label: 'حضور',
    obStep4Label: 'سلیقه',
    obStep5Label: 'شعاع',
    obIdTitle: 'وارد شده از تلگرام',
    obLinked: 'متصل',
    obTgVerified: 'تأیید تلگرام',
    obDisplayName: 'نام نمایشی',
    obBirthday: 'تاریخ تولد',
    obDayPh: 'روز',
    obMonthPh: 'ماه',
    obYearPh: 'سال',
    obAgeNote: 'شما {age} ساله‌اید — سن عمومی است، تاریخ تولد نه.',
    obPhonePrivacy: 'شماره تلفن تلگرام شما هرگز فاش نمی‌شود. مچ‌ها فقط پروفایل FLM شما را می‌بینند.',
    obErrDay: 'روز معتبر وارد کنید (۱–۳۱)',
    obErrMonth: 'ماه معتبر وارد کنید (۱–۱۲)',
    obErrYear: 'سال معتبر وارد کنید ({min}–{max})',
    obErrDate: 'چنین تاریخی وجود ندارد — روز و ماه را بررسی کنید.',
    obErrFuture: 'تاریخ تولد نمی‌تواند در آینده باشد.',
    obErrAge: 'برای استفاده از FLM باید ۱۸ سال یا بیشتر داشته باشید.',
    obIntentTitle: 'برای چه کسی اینجایی؟',
    obIAm: 'من هستم',
    obShowMe: 'نشانم بده',
    obBeyond: 'فراتر',
    obLookingFor: 'به دنبالِ',
    obReal: 'رابطه جدی',
    obRealSub: 'بلندمدت و متعهد',
    obOpen: 'بدون عجله ببینیم',
    obOpenSub: 'قرار، بدون فشار',
    obFriends: 'اول دوستی',
    obFriendsSub: 'آرام‌آرام؛ رویدادها و دورهمی‌ها',
    obPresenceTitle: 'بهترین جلوه‌ات را نشان بده',
    obMainPhoto: 'عکس اصلی',
    obNMore: '{n} عکس دیگر',
    obAiCheck: 'عکس‌ها برای اصالت با هوش مصنوعی بررسی می‌شوند ← نشان {verified} می‌گیرید.',
    obVerifiedWord: 'تأییدشده',
    obVoiceBoost: 'پروفایل‌های دارای معرفی صوتی ۳ برابر بیشتر مچ می‌گیرند.',
    obSkipVoice: 'معرفی صوتی — بعداً ضبط کن',
    obTasteTitle: '۵ چیزی که عاشقشی انتخاب کن',
    obPromptLabel: 'جمله آغاز گفتگو',
    obTwoTruths: 'دو حقیقت و یک دروغ',
    obPromptExample: 'در سه کشور دی‌جی بوده‌ام، یک اختراع ثبت‌شده دارم و هرگز سوشی نخورده‌ام.',
    obPromptHint: 'مچ‌ها برای شکستن یخ، دروغ را حدس می‌زنند 🧊',
    obShuffle: 'یک جمله دیگر',
    obRadiusTitle: 'جایی که عشق پیدایت می‌کند',
    obDiscoveryRadius: 'شعاع کشف',
    obGhostMode: 'حالت روح',
    obGhostSub: 'ناشناس در نقشه بگرد · پرمیوم',
    obEnterFlm: 'ورود به FLM',
    obLocationOff: 'فقط شهر — موقعیت دقیق خاموش',
    obLocationRequired: 'برای ادامه موقعیتت را تنظیم کن — فعالش کن، پین بگذار، یا شهرت را وارد کن.',
    /* بازسازی ویزارد: عکس اصلی الزامی + برش، بازبینی صدا، نقشه واقعی */
    obMainPhotoReq: 'دست‌کم ۲ عکس اضافه کن — عکس اصلی و یک عکس دیگر',
    obVerifying: 'در حال بررسی عکس‌ها… باید عکس واقعی خودت باشند.',
    obAiChecking: 'بررسی هوش مصنوعی…',
    photoMinRemove: 'دست‌کم ۲ عکس نگه دار — قبل از حذف، یک عکس جدید اضافه کن.',
    obCropTitle: 'عکس را تنظیم کن',
    obCropHint: 'برای جابه‌جایی بکش · برای زوم اسلایدر یا دو انگشت',
    obCropAvatar: 'پیش‌نمایش آواتار — همان‌طور که مچ‌ها می‌بینند',
    obCropUse: 'استفاده از عکس',
    obZoom: 'بزرگ‌نمایی',
    cancel: 'انصراف',
    obRecordVoice: 'ضبط معرفی صوتی',
    obStopRec: 'توقف',
    obOptional: 'اختیاری',
    micUnavailable: 'میکروفون در دسترس نیست',
    obLocating: 'در حال یافتن موقعیت…',
    obUploadErr: 'آپلود عکس انجام نشد — روی کادر بزن و دوباره تلاش کن.',
    obFinishErr: 'ثبت‌نام کامل نشد',
    obFinishing: 'در حال ذخیره پروفایل…',

    updateTitle: 'نسخه جدیدی در دسترس است',
    updateBody: 'برای دریافت آخرین نسخه FLM تازه‌سازی کنید.',
    updateCta: 'تازه‌سازی',

    discover: 'کشف',
    deck: 'کارت',
    orbit: 'مدار',
    likesYou: 'لایک‌ها',
    filters: 'فیلترها',
    distance: 'فاصله',
    ageRange: 'بازه سنی',
    filterGlobal: 'جهانی',
    likesPaywallCta: 'ببین چه کسانی لایکت کرده‌اند — پرمیوم شو',
    pass: 'رد',
    like: 'بله',
    spark: 'جرقه',
    matchTitle: 'مَچ شدید',
    matchBody: 'شما و {name} به هم بله گفتید.',
    sendMessage: 'ارسال پیام',
    keepSwiping: 'ادامه بده',
    about: 'درباره',
    interests: 'علاقه‌مندی‌ها',
    voiceIntro: 'معرفی صوتی',
    inCommon: '{n} مورد مشترک',
    deckEmpty: 'فعلاً همین بود',
    deckEmptyBody: 'هر روز افراد جدیدی اضافه می‌شوند. فیلترها را بازتر کنید یا بعداً سر بزنید.',
    orbitHint: 'روی یک چهره بزنید تا کارتش باز شود',
    youCenter: 'شما',

    favorites: 'برگزیده‌ها',
    likedYouN: '{n} نفر شما را لایک کرده‌اند',
    revealLikes: 'ببین چه کسانی لایکت کرده‌اند',
    revealNote: 'با پرمیوم همین حالا چهره‌ها را ببینید.',

    pulse: 'نبض',
    stories: 'استوری‌ها',
    yourStory: 'استوری شما',
    reply: 'پاسخ',
    shareMoment: 'یک لحظه را به اشتراک بگذارید…',
    likedYourPost: 'پست شما را پسندید',

    nearby: 'اطراف',
    radius: 'شعاع',
    liveNow: 'هم‌اکنون',
    eventsNearby: 'رویدادهای نزدیک',
    going: '{n} نفر می‌روند',
    join: 'می‌روم',
    joined: 'ثبت شد',

    chats: 'گفتگوها',
    newMatches: 'مچ‌های جدید',
    icebreakers: 'یخ‌شکن‌ها',
    typeMessage: 'پیام…',
    photoMessage: 'عکس',
    viewProfile: 'مشاهده پروفایل',
    gift: 'هدیه',
    sendGift: 'ارسال هدیه',
    giftNote: 'با TON خریداری و فوراً به پروفایلش ارسال می‌شود.',
    videoCall: 'تماس تصویری',
    chatLimitTitle: 'به سقف پیام روزانه رسیدی',
    chatLimitBody: 'با پرمیوم پیام‌هایت نامحدود می‌شود',
    today: 'امروز',
    you: 'شما',
    sentGift: 'شما یک هدیه فرستادید',
    unmatch: 'حذف مچ',
    unmatchSub: 'حذف مچ و گفتگو',
    blockSub: 'دیگر همدیگر را نمی‌بینید',
    reportSub: 'گزارش این پروفایل به تیم ما',
    reportWhy: 'چه اتفاقی افتاد؟',
    rrSpam: 'هرزنامه',
    rrHarassment: 'آزار و اذیت',
    rrNudity: 'محتوای نامناسب',
    rrScam: 'کلاهبرداری',
    rrFake: 'پروفایل جعلی',
    rrOther: 'سایر',
    /* report wizard */
    reportStepReason: 'دلیل',
    reportStepDetails: 'جزئیات',
    reportDetailsTitle: 'افزودن جزئیات',
    reportDetailsSub: 'هر چیزی که به بررسی تیم ما کمک کند (اختیاری).',
    reportDetailsPlaceholder: 'بنویس چه اتفاقی افتاد…',
    reportSend: 'ارسال گزارش',
    reportSending: 'در حال ارسال…',
    reportSentTitle: 'گزارش ارسال شد',
    reportSentSub: 'ممنون که به امن نگه‌داشتن FLM کمک کردی. تیم ما بررسی می‌کند — و این شخص را هم مسدود کردیم، پس دیگر همدیگر را نمی‌بینید.',
    blockTitle: 'این شخص مسدود شود؟',
    blockBody: 'دیگر نمی‌تواند تو را ببیند یا پیام دهد و هر مچی حذف می‌شود. بعداً می‌توانی این کار را برگردانی.',
    reportFailed: 'ارسال نشد — دوباره تلاش کن.',

    premium: 'پرمیوم',
    premiumTitle: 'آشنایی در کلاس فرست‌کلس',
    premiumSub: 'همه‌چیز نامحدود. همه‌جا اول دیده شوید.',
    mostPopular: 'محبوب‌ترین',
    upgrade: 'ارتقا',
    month: 'ماه',
    months: 'ماه',
    payWithCrypto: 'پرداخت با کریپتو',
    checkout: 'پرداخت',
    coin: 'ارز',
    amount: 'مبلغ',
    address: 'آدرس',
    copy: 'کپی',
    copied: 'کپی شد',
    ivePaid: 'پرداخت کردم',
    verifying: 'در حال تأیید روی زنجیره…',
    youArePremium: 'شما پرمیوم شدید',
    premiumDoneBody: 'به {plan} خوش آمدید. حالا همه‌چیز نامحدود است.',
    tgStars: 'استارز تلگرام',
    perkUnlimited: 'بله و بازگشت نامحدود',
    perkSeeLikes: 'ببین چه کسانی لایکت کرده‌اند',
    perkBoost: 'هر هفته یک بوست رایگان',
    perkSparks: 'روزی ۵ جرقه',
    perkIncognito: 'گشت‌وگذار ناشناس',
    perkPassport: 'پاسپورت — هر شهری که بخواهی',
    perkVerifiedOnly: 'فقط مچ با تأییدشده‌ها',
    perkConcierge: 'بازبینی و مشاوره پروفایل',
    /* پرک‌های هر سطح — هر پلن عددهای واقعی خودش را نشان می‌دهد. */
    perkSparks5: 'روزی ۵ جرقه',
    perkSparks10: 'روزی ۱۰ جرقه',
    perkBoost1: 'هر هفته یک بوست رایگان',
    perkBoost3: 'هر هفته ۳ بوست رایگان',
    perkRewind: 'بازگرداندن آخرین سوایپ',
    perkMessageFirst: 'پیام قبل از مچ شدن',

    profile: 'پروفایل',
    editProfile: 'ویرایش پروفایل',
    epSub: 'بیو، شغل، علاقه‌مندی‌ها و عکس‌ها',
    epBioPh: 'چند خط درباره خودت…',
    epJobPh: 'چه کاری انجام می‌دهی؟',
    job: 'شغل',
    settings: 'تنظیمات',
    language: 'زبان',
    photos: 'عکس‌ها',
    strength: 'قدرت پروفایل',
    getVerified: 'تأیید هویت',
    verifiedNote: 'یک سلفی ویدیویی ۱۰ ثانیه‌ای. FLM را واقعی نگه می‌دارد.',
    wallet: 'کیف پول',
    boost: 'بوست',
    boostNote: '۳۰ دقیقه پروفایل اول اطراف باش',
    notifications: 'اعلان‌ها',
    privacy: 'حریم خصوصی',
    logout: 'خروج',
    memberSince: 'عضو از',
  },
};

export function makeT(lang) {
  const dict = FLM_I18N[lang] || FLM_I18N.en;
  const en = FLM_I18N.en;
  return function t(key, vars) {
    let s = dict[key] != null ? dict[key] : en[key] != null ? en[key] : key;
    if (vars) {
      Object.keys(vars).forEach((k) => {
        s = s.split('{' + k + '}').join(String(vars[k]));
      });
    }
    return s;
  };
}

/* Persian digit helper — used for FA locale numbers */
export function faDigits(str) {
  const map = { 0: '۰', 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹' };
  return String(str).replace(/[0-9]/g, (d) => map[d]);
}

/* Merge screen-port additions (English primary; FA best-effort). */
Object.assign(FLM_I18N.en, I18N_ADDITIONS.en);
Object.assign(FLM_I18N.fa, I18N_ADDITIONS.fa);

/* Real-data-only strings: Telegram gate, auth retry, loading and the designed
   empty/error states that replaced the silent FLM_DATA fallback. */
const REAL_DATA_I18N = {
  en: {
    gateBody: 'FLM lives inside Telegram. Open @FindLoveMateBot to start.',
    gateCta: 'Open in Telegram',
    gateHint: 'Reviewing the design? Add ?demo=1 to browse with sample data.',
    authErrTitle: "Couldn't sign you in",
    authErrBody: "The Telegram sign-in didn't go through. Check your connection and retry.",
    retry: 'Retry',
    loadingLabel: 'Loading…',
    refresh: 'Refresh',
    emptyDeckTitle: 'No one new nearby yet',
    emptyDeckNote: 'Widen your radius in filters.',
    likesEmptyNote: 'No likes yet — keep swiping.',
    chatsEmptyTitle: 'No conversations yet',
    chatsEmptyNote: 'Match with someone first.',
    feedEmptyTitle: 'Nothing in Pulse yet',
    feedEmptyNote: 'Share the first post.',
    eventsEmptyTitle: 'No events yet',
    eventsEmptyNote: 'Check back soon.',
    mapNoLocTitle: 'Location not set',
    mapNoLocNote: 'Enable location to see people nearby.',
    locSetManually: 'Set location manually',
    locPickTitle: 'Set your location',
    locPickHint: 'Drag the map to position the pin',
    locUseThis: 'Use this location',
    locDetecting: 'Detecting your area…',
    locChange: 'Change',
    plansEmptyTitle: 'No plans available',
    plansEmptyNote: 'Check back soon.',
    errTitle: 'Something went wrong',
    errNote: "Couldn't reach FLM — try again.",
    nearestLabel: 'Nearby right now',
    mapNearbyLive: '{n} nearby',
    mapLockedCta: '{n} people near you · unlock with Premium',
    mapTravel: 'Travel — change location (Passport)',
    hubNotVerified: 'Not verified',
    hubWalletTitle: 'TON Connect',
    hubWalletSubLive: 'Pay-per-use, non-custodial',
    subTonLive: 'TON Connect · non-custodial',
  },
  fa: {
    gateBody: 'FLM داخل تلگرام زندگی می‌کند. برای شروع @FindLoveMateBot را باز کنید.',
    gateCta: 'باز کردن در تلگرام',
    gateHint: 'بازبینی طراحی؟ ?demo=1 را اضافه کنید تا با داده نمونه بگردید.',
    authErrTitle: 'ورود انجام نشد',
    authErrBody: 'ورود با تلگرام کامل نشد. اتصال را بررسی کنید و دوباره تلاش کنید.',
    retry: 'تلاش دوباره',
    loadingLabel: 'در حال بارگذاری…',
    refresh: 'تازه‌سازی',
    emptyDeckTitle: 'فعلاً کسی در نزدیکی نیست',
    emptyDeckNote: 'شعاع را در فیلترها بیشتر کنید.',
    likesEmptyNote: 'هنوز لایکی نیست — به ورق‌زدن ادامه بده.',
    chatsEmptyTitle: 'هنوز گفتگویی نیست',
    chatsEmptyNote: 'اول با کسی مچ شو.',
    feedEmptyTitle: 'هنوز چیزی در پالس نیست',
    feedEmptyNote: 'اولین پست را به اشتراک بگذار.',
    eventsEmptyTitle: 'هنوز رویدادی نیست',
    eventsEmptyNote: 'بعداً سر بزن.',
    mapNoLocTitle: 'موقعیت تنظیم نشده',
    mapNoLocNote: 'برای دیدن افراد نزدیک، موقعیت مکانی را فعال کن.',
    locSetManually: 'تنظیم دستی موقعیت',
    locPickTitle: 'موقعیتت را تنظیم کن',
    locPickHint: 'نقشه را بکش تا پین روی جای درست قرار بگیرد',
    locUseThis: 'استفاده از این موقعیت',
    locDetecting: 'در حال تشخیص منطقه‌ات…',
    locChange: 'تغییر',
    plansEmptyTitle: 'طرحی موجود نیست',
    plansEmptyNote: 'بعداً سر بزن.',
    errTitle: 'مشکلی پیش آمد',
    errNote: 'اتصال به FLM برقرار نشد — دوباره تلاش کن.',
    nearestLabel: 'همین حالا در نزدیکی',
    mapNearbyLive: '{n} نفر در نزدیکی',
    mapLockedCta: '{n} نفر در نزدیکی شما · با پریمیوم ببینید',
    mapTravel: 'سفر — تغییر موقعیت (پاسپورت)',
    hubNotVerified: 'تأیید نشده',
    hubWalletTitle: 'TON Connect',
    hubWalletSubLive: 'پرداخت به‌ازای مصرف · بدون امانت‌سپاری',
    subTonLive: 'TON Connect · بدون امانت‌سپاری',
  },
};
Object.assign(FLM_I18N.en, REAL_DATA_I18N.en);
Object.assign(FLM_I18N.fa, REAL_DATA_I18N.fa);

/* Profile/media round: Telegram identity row, voice upload retry and the
   profile-strength checklist (mirrors profiles.service.ts strengthOf()). */
const PROFILE_MEDIA_I18N = {
  en: {
    tgLinked: 'Telegram linked',
    voiceUploadErr: "Voice upload didn't go through.",
    csTitle: 'Reach 100%',
    csSub: 'Finish these and your profile hits 100% — stronger profiles match more.',
    csBasics: 'Name, birthday & gender',
    csPhoto: 'Add at least one photo',
    csInterests: 'Pick 5 interests',
    csBio: 'Write a short bio',
    csJob: 'Add your job',
    csVoice: 'Record a voice intro',
    csPct: '+{n}%',
  },
  fa: {
    tgLinked: 'متصل به تلگرام',
    voiceUploadErr: 'آپلود صدا انجام نشد.',
    csTitle: 'به ۱۰۰٪ برس',
    csSub: 'این موارد را کامل کن تا پروفایلت ۱۰۰٪ شود — پروفایل قوی‌تر مچ بیشتری می‌گیرد.',
    csBasics: 'نام، تاریخ تولد و جنسیت',
    csPhoto: 'دست‌کم یک عکس اضافه کن',
    csInterests: '۵ علاقه‌مندی انتخاب کن',
    csBio: 'یک بیو کوتاه بنویس',
    csJob: 'شغلت را اضافه کن',
    csVoice: 'یک معرفی صوتی ضبط کن',
    csPct: '+{n}٪',
  },
};
Object.assign(FLM_I18N.en, PROFILE_MEDIA_I18N.en);
Object.assign(FLM_I18N.fa, PROFILE_MEDIA_I18N.fa);

/* Admin-managed overrides (GET /v1/i18n/:locale): mutates the dict makeT closes
   over, so live t() calls pick the new strings up — callers re-render once. */
export function applyI18nOverrides(locale, entries) {
  if (!entries || typeof entries !== 'object') return 0;
  const dict = FLM_I18N[locale] || (FLM_I18N[locale] = {});
  let applied = 0;
  for (const key of Object.keys(entries)) {
    if (typeof entries[key] === 'string') {
      dict[key] = entries[key];
      applied += 1;
    }
  }
  return applied;
}
